import React from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import Button from '../../../components/common/ui/Button';
import { getDeviceDataFromMapping } from '../../../utils/devices';
import ErrorSmileIcon from '../../../assets/icons/activate/ErrorSmileIcon';
import useIsOnline from '../../../hooks/useIsOnline';

import styles from './styles.module.scss';

const ActivationOfflineError = ({
  deviceInfo,
  continueActivationAfterLostConnection,
  productVariant,
  openErrorScreen,
  openPaymentErrorScreen,
  openCompleteScreen,
  openProcessingScreen,
  openOfflineScreen,
}) => {
  const isOnline = useIsOnline();
  const dataFromMapping = getDeviceDataFromMapping(
    deviceInfo?.device_info?.device_type_name,
  );
  const deviceImagePath = dataFromMapping?.activationImagePath;

  const continueActivation = () => {
    continueActivationAfterLostConnection({
      productVariant,
      setLoading: () => {},
      setError: () => {},
      openErrorScreen,
      openPaymentErrorScreen,
      openCompleteScreen,
      openProcessingScreen,
      openOfflineScreen,
    });
  };

  return (
    <ActivationBox
      className={cn(styles.wrapper, { [styles.noDevice]: !deviceImagePath })}
    >
      <img src={deviceImagePath} alt="" className={styles.deviceImage} />
      <div className={styles.content}>
        <ErrorSmileIcon />
        <h3 className={cn('h3', styles.title)}>Oops, you lost connection.</h3>
        <p className={cn('text-s', styles.text)}>
          Please make sure to restore your connection before proceeding.
        </p>
        <Button
          className={styles.button}
          onClick={continueActivation}
          disabled={!isOnline}
        >
          Continue
        </Button>
      </div>
    </ActivationBox>
  );
};

export default ActivationOfflineError;
